/* globals Mousetrap */
/* exported Metronome */

var Metronome = {
	interval: null, // used to store the result of setInterval() while ticking

	context: (function () { // audio context in which to create and use the tick tone generator
		var contextClass = (window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.oAudioContext || window.msAudioContext);
		if (contextClass) {
			return new contextClass();
		} else {
			console.warn('AudioContext not supported');
		}
	})(),

	settings: {
		tempo: 120,
		time: 0,
		duration: 0.02,
		frequencie: 1500,		
	},

	tick: function () {
		var osc = Metronome.context.createOscillator();
		osc.frequency.value = Metronome.settings.frequencie;			
		// audio tick
		osc.connect(Metronome.context.destination);
		osc.start(Metronome.context.currentTime);
		osc.stop(Metronome.context.currentTime + Metronome.settings.duration);
	},

	start: function (bpm) {
		// ios does not play html5 audio on a page unless first triggered by a user interaction event like this		
		var osc = Metronome.context.createOscillator();
		osc.connect(Metronome.context.destination);
		osc.start(Metronome.context.currentTime);
		osc.stop(Metronome.context.currentTime);
		Metronome.settings.tempo=60000 / bpm
		if (Metronome.interval !== null) {
			window.clearInterval(Metronome.interval);
		}
		Metronome.interval = window.setInterval(Metronome.tick, Metronome.settings.tempo);
	},

	stop: function () {
		window.clearInterval(Metronome.interval);
		Metronome.interval = null;		
	}
};

export function startMetronome(bpm) {
	if (bpm==0) {
		Metronome.stop() }
	else {		
	Metronome.start(bpm) }
}